// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"47edae9a","89":"d98b932e","163":"59ca3104","585":"9a126391","894":"43c15100","928":"6ac7981e"}[chunkId] + ".chunk.js";
};